import { menuListItems } from 'assets/menu/menuList';
import { BreadCrumb } from 'components/BreadCrumb';
import { GoToBack } from 'components/GoToBack';
import { Header } from 'components/Header';
import { Menu } from 'components/Menu';
import React, {  } from 'react';
import { SellerLeadForm } from '../SellerLeadForm';

import { HeaderContainer } from './styles';
import { useSellerLeadNew } from './useSellerLeadNew';

export const SellerLeadNew: React.FC = () => { 
  const {
    handleInputChange,
    handleSelectChange,
    checklist,
    inputsValues,
    touched,
    errors,
    properties,
    imagePath,
    handlerImageSelected,
    socialMedias,
    handleRemoveContact,
    handleAddContact,
    changeFooter,
    showAlertForm,
    submitButton,
    changeNameTag,
    handleSubmit,
    hasError,
    isLoading,
    statusAnalysisLead,
    usersOptions,
    category,
    socialMediaTypes,
    contactTypes,
    logoIsPNG
  } = useSellerLeadNew();

  return (
    <Menu links={menuListItems}>
      <Header>
        <HeaderContainer>
          <div>
            <GoToBack />
          </div>

          <div className="header-text">
            <BreadCrumb itens={["Novos cadastros", "Novo"]} itemActive="Novo" />
          </div>
        </ HeaderContainer>
      </Header>

      <SellerLeadForm
        // handleChangeRadioOfChecklist={handleChangeRadioOfChecklist}
        logoIsPNG={logoIsPNG}
        handleChange={handleInputChange}
        checklist={checklist}
        inputsValues={inputsValues}
        touched={touched}
        errors={errors}
        handleSelectChange={handleSelectChange}
        properties={properties}
        imagePath={imagePath}
        handlerImageSelected={handlerImageSelected}
        socialMedias={socialMedias}
        handleRemoveContact={handleRemoveContact}
        handleAddContact={handleAddContact}
        changeFooter={changeFooter}
        handleSubmit={handleSubmit}
        showAlertForm={showAlertForm}
        submitButton={submitButton}
        changeNameTag={changeNameTag}
        hasError={hasError}
        isLoading={isLoading}
        statusAnalysisLead={statusAnalysisLead}    
        usersOptions={usersOptions}
        category={category}       
        socialMediaTypes={socialMediaTypes}
        contactTypes={contactTypes}   
        setStatusToLead={() => {}}
        setReasonToLeadReproved={() => {}}
      />
      
    </Menu>
  );
}
